import React, {useEffect, useState} from 'react';
import ReactModal from "react-modal";
import Select from "react-select";

import "./PDSAActTabOne.css";
import {StandardButton} from "../../../../../../common/button/standard-button/StandardButton";
import {BackButton} from "../../../../../../common/button/back-button/BackButton";
import {ToolTip} from "../../../../../../common/tool-tip/ToolTip";


export const PDSAActTabOne = ({
                                  context,
                                  setContext,
                                  PDSA,
                                  setPDSA,
                                  navigateTo,
                                  savePDSA,
                                  setActiveTab,
                                  setCurrentScreen,
                                  active,
                                  showToaster,
                                  toolTipsEnabled,
                                  setSpinnerText
                              }) => {

    ReactModal.setAppElement('#root');

    const [statusList, setStatusList] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedStatusLabel, setSelectedStatusLabel] = useState(null);
    const [initialStatusLabel, setInitialStatusLabel] = useState(null);

    useEffect(() => {
        setInitialStatusLabel(PDSA.status.label);
        setStatusList([
            {value: 1, label: "Abandon"},
            {value: 2, label: "Adopt"},
            {value: 3, label: "Adapt"},
            {value: 4, label: "Scale Up"},
            {value: 5, label: "Test Under Different Conditions"},
        ]);
        setActiveTab("act");
    }, []);

    const handleStatusChange = (selectedStatus) => {
        setSelectedStatusLabel(selectedStatus.label);
        if (selectedStatus.label === "Abandon" || selectedStatus.label === "Adopt") {
            setPDSA((prevState) => ({
                ...prevState,
                status: selectedStatus,
                rationale: "",
            }));
        } else {
            setPDSA((prevState) => ({
                ...prevState,
                status: selectedStatus,
            }));
        }
    }

    const savePDSAVersion = (versionPDSA) => {
        savePDSA(() => {
            if (PDSA.status.label === "Adapt") {
                navigateTo("changeIdeaOne");
            } else {
                setContext((prevState) => ({
                    ...prevState,
                    problemToBeViewedExternalReference: context.problemScreen.externalReference,
                }));
                navigateTo("problemTree");
            }
        }, versionPDSA);
    }

    const handleSaveClick = () => {
        if (initialStatusLabel === "Abandon" || initialStatusLabel === "Adopt" || initialStatusLabel === "In Progress") {
            savePDSAVersion(false);
        } else if (!selectedStatusLabel) {
            setShowModal(true);
        } else {
            if (initialStatusLabel === selectedStatusLabel || !selectedStatusLabel) {
                setShowModal(true);
            } else {
                savePDSAVersion(false);
            }
        }
    }

    const handleSaveChangesToExistingPDSAClick = () => {
        setShowModal(false);
        savePDSAVersion(false);
    }

    const handleCreateNextPDSAClick = () => {
        setShowModal(false);
        savePDSAVersion(true);
    }


    const isButtonDisabled = () => {
        if (active) {
            if (PDSA.status) {
                if (PDSA.status.label !== "Abandon" && PDSA.status.label !== "Adopt" && PDSA.status.label !== "In Progress") {
                    return !PDSA.rationale;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    return (
        <div className="act-tab-one-container">
            <div className="act-tab-one-input-container">
                <div className="input-container">
                    <div>
                        <label>Status:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"pdsaStatus123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Status:"}/>}
                    </div>
                    <Select options={statusList}
                            onChange={(selectedStatus) => handleStatusChange(selectedStatus)}
                            value={PDSA.status}
                            classNamePrefix="select"
                            isDisabled={!active || context.PDSAScreen.status.label === "Abandon" || context.PDSAScreen.status.label === "Adopt"}
                    />
                </div>
                {(PDSA.status && (PDSA.status.label !== "Abandon" && PDSA.status.label !== "Adopt" && PDSA.status.label !== "In Progress")) &&
                <div className="input-container">
                    <div>
                        <label>Next Steps Rationale:</label>
                        {toolTipsEnabled &&
                        <ToolTip tooltipExternalReference={"pdsaNextStepsRationale123"}
                                 context={context}
                                 setSpinnerText={setSpinnerText} showToaster={showToaster}
                                 fieldName={"Next Steps Rationale:"}/>}
                    </div>
                    <textarea defaultValue={PDSA.rationale ? PDSA.rationale : null}
                              disabled={!active}
                              onChange={({target}) => {
                                  setPDSA((prevState) => ({
                                      ...prevState,
                                      rationale: target.value
                                  }));
                              }}/>
                </div>}
            </div>
            <div className="back-to-overview-pdsa-button-container">
                <StandardButton text="Problem Overview" onClick={() => {
                    navigateTo("problemTree");
                }}/>
            </div>
            <div className="act-tab-one-save-pdsa-button-container">
                <StandardButton text="Save PDSA" disabled={isButtonDisabled()} onClick={handleSaveClick}/>
            </div>
            <div className="act-one-back-button-container">
                <BackButton onClick={() => {
                    setCurrentScreen("PDSAStudyTabOne");
                }}/>
            </div>
            <ReactModal isOpen={showModal} className="modal-content" overlayClassName="modal-overlay">
                <p className={"modal-header-pdsa"}>{"Would you like to: "}</p>
                <div className={"modal-button-group-pdsa"}>
                    <StandardButton onClick={handleSaveChangesToExistingPDSAClick}
                                    text={"Save changes to existing PDSA"}/>
                    <StandardButton onClick={handleCreateNextPDSAClick} text={"Create next PDSA cycle"}/>
                    <StandardButton onClick={() => setShowModal(!showModal)} text={"Go Back"}/>
                </div>
            </ReactModal>
        </div>
    );
}
